import DeviationPage from './StashPage';
import DeviationPageContainer from '../DeviationPage.container';

export default DeviationPageContainer(DeviationPage);
